import Axios from './Axios';

export const PublicProfileS = {
  getProfile: (doctorId) => Axios.get(`/doctor-data/user-profile/${doctorId}`),
  updateProfile: (values) => Axios.patch('/doctor-data/update-doctor-user', values),
  documentTypes: () => Axios.get('/admin-setup/document-types')
};
